<template>
  <a-modal
    :title="language['common.action']"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['depart.management.departName']"
          prop="departName"
          :hidden="false"
          hasFeedback>
          <a-input id="departName" placeholder="" v-model="model.departName" :disabled="true"/>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['depart.management.transferTo']">
          <a-tree-select
            style="width:100%"
            :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
            :treeData="treeData"
            v-model="model.parentId"
            :placeholder="language['common.not']">
          </a-tree-select>
        </a-form-model-item>

        <a-transfer
          :data-source="mockData"
          :target-keys="targetKeys"
          :disabled="disabled"
          :show-search="showSearch"
          :filter-option="(inputValue, item) => item.title.indexOf(inputValue) !== -1"
          :show-select-all="false"
          :operations="[language['depart.management.transferIn'], language['depart.management.transferOut']]"
          @change="onChange"
        >
          <template
            slot="children"
            slot-scope="{
              props: { direction, filteredItems, selectedKeys, disabled: listDisabled },
              on: { itemSelectAll, itemSelect }, }" >
            <a-table
              :row-selection="getRowSelection({ disabled: listDisabled, selectedKeys, itemSelectAll, itemSelect })"
              :columns="direction === 'left' ? leftColumns : rightColumns"
              :data-source="filteredItems"
              size="small"
              :style="{ pointerEvents: listDisabled ? 'none' : null }"
              :custom-row="({ key, disabled: itemDisabled }) => ({
                on: {
                  click: () => {
                    if (itemDisabled || listDisabled) return;
                    itemSelect(key, !selectedKeys.includes(key));
                  },
                },
              })
            "
            />
          </template>
        </a-transfer>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import {getAction, postAction, httpAction} from '@/api/manage'
  import {queryIdTree, queryDepartTreeList} from '@/api/api'
  import { get, pick } from 'lodash';
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import moment from "moment";
  import difference from 'lodash/difference';
  // const mockData = [];
  // for (let i = 0; i < 20; i++) {
  //   mockData.push({
  //     key: i.toString(),
  //     title: `content${i + 1}`,
  //     description: `description of content${i + 1}`,
  //     // disabled: i % 4 === 0,
  //   });
  // }
  // const originTargetKeys = mockData.filter(item => +item.key % 3 > 1).map(item => item.key);
 /* const leftTableColumns = [
    {
      dataIndex: 'title',
      title: '用户账号',
    },
    {
      dataIndex: 'description',
      title: '工号',
    },
  ];
  const rightTableColumns = [
    {
      dataIndex: 'title',
      title: '用户账号',
    },
  ];*/

  export default {
    name: "DepartTransferEmployeeModal",
    components: {ATextarea},
    computed:{
      language() {
        return this.$store.getters.language
      },
      leftColumns(){
        if(this.language){
          return [
            {
              dataIndex: 'title',
              title: this.language['user.column.userName'],
            },
            {
              dataIndex: 'description',
              title: this.language['user.column.workNo'],
            },
          ];
        }
      }  ,
      rightColumns(){
          if(this.language){
            return [
              {
                dataIndex: 'title',
                title: this.language['user.column.userName'],
              },
            ];
          }
      }
    },
    data() {
      return {
        sourceParentId:"",
        mockData:[],
        targetKeys: [],
        disabled: false,
        showSearch: false,
       /* leftColumns: leftTableColumns,
        rightColumns: rightTableColumns,*/
        iExpandedKeys: [],
        allTreeKeys: [],
        allTreeNodes: [],
        treeData: [],
        nextDepartOptions: [],
        isPreviousOrNot: false,
        dateFormat: "YYYY-MM-DD",
        artificialPersonList: [{
          id: '',
          applicationName: ''
        }],
        siteCodeList: [{
          id: '',
          xxx: ''
        }],
        departTree: [],
        orgTypeData: [],
        phoneWarning: '',
        departName: "",
        // title: "操作",
        seen: false,
        visible: false,
        condition: true,
        disableSubmit: false,
        model: {},
        defaultModel: {
          departOrder: 0,
          orgCategory: '1'
        },
        menuhidden: false,
        menuusing: true,
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },

        confirmLoading: false,
        validatorRules: {
          departName: [{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['depart.management.departName']}],
        },
        url: {
          add: "/sys/sysDepart/add",
          loadLeftTableUrl:"/sys/user/departUserListNoPage",
          transferEmployee:'sys/sysDepart/transferEmployee',
        },
        dictDisabled: true,
      }
    },
    created() {

    },
    methods: {
      loadLeftTable(departId){
        let that = this;
        let params = {};
        params.depId = departId;
        getAction(this.url.loadLeftTableUrl, params).then((res) => {
          if (res.success && res.result) {
            res.result.map((row) => {
              let param = {};
              param.key = row.id;
              param.title = row.username;
              param.description = row.workNo;
              that.mockData.push(param);
            })
          }
        })
      },

      onChange(nextTargetKeys) {
        this.targetKeys = nextTargetKeys;
      },
      triggerDisable(disabled) {
        this.disabled = disabled;
      },
      triggerShowSearch(showSearch) {
        this.showSearch = showSearch;
      },
      getRowSelection({ disabled, selectedKeys, itemSelectAll, itemSelect }) {
        return {
          getCheckboxProps: item => ({ props: { disabled: disabled || item.disabled } }),
          onSelectAll(selected, selectedRows) {
            const treeSelectedKeys = selectedRows.filter(item => !item.disabled).map(({ key }) => key);
            const diffKeys = selected ? difference(treeSelectedKeys, selectedKeys) : difference(selectedKeys, treeSelectedKeys);
            itemSelectAll(diffKeys, selected);
          },
          onSelect({ key }, selected) {
            itemSelect(key, selected);
          },
          selectedRowKeys: selectedKeys,
        };
      },

      loadTreeData(id) {
        let that = this
        that.treeData = []
        that.departTree = []
        queryDepartTreeList({'applicationCode':this.$store.getters.applicationCode}).then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            this.allTreeKeys = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              this.getDisabledKeys(temp, id);
              that.treeData.push(temp)
              that.departTree.push(temp)
              that.setThisExpandedKeys(temp)
              that.getAllKeys(temp);
            }
          }
        })
      },
      setThisExpandedKeys(node) {
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys.push(node.key)
          for (let a = 0; a < node.children.length; a++) {
            this.setThisExpandedKeys(node.children[a])
          }
        }
      },
      getAllKeys(node) {
        this.allTreeKeys.push(node.key)
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllKeys(node.children[a])
          }
        }
      },
      getDisabledKeys(node, id) {
        if(node.id == id){
          node.disabled = true;
          return;
        }
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getDisabledKeys(node.children[a], id)
          }
        }
      },
      add(depart) {
        if (depart) {
          this.seen = false;
          this.dictDisabled = false;
        } else {
          this.seen = true;
          this.dictDisabled = true;
        }
        this.edit(depart);
      },
      edit(record) {
        this.visible = true;
        this.model = Object.assign({}, this.defaultModel, record)
        this.model.parentId = record ? record.parentId : null;
        this.sourceParentId = this.model.parentId;
        this.loadLeftTable(this.model.id);
        this.loadTreeData(this.model.id);
      },
      close() {
        this.$emit('close');
        this.disableSubmit = false;
        this.visible = false;
        this.isPreviousOrNot = false;
        this.mockData = [];
        this.targetKeys = [];
        this.$refs.form.resetFields();
      },
      handleOk() {
        let that = this;
        let param = {};
        param.targetParentId = this.model.parentId;
        param.sourceParentId = this.sourceParentId;
        param.targetUserIds = this.targetKeys.join(",");
        if(this.targetKeys == undefined || this.targetKeys.length == 0){
          this.$warning({ title: this.language['operationfailed'], content: this.language['depart.management.warning.chooseTransferUser'] })
          return false;
        }
        that.confirmLoading = true;
        httpAction(this.url.transferEmployee, param, "post").then((res)=>{
          if(res.success){
            that.$message.success(res.message);
            // that.loadTreeData();
            that.$emit('ok');
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
          that.close();
        })
      },
      handleCancel() {
        this.close()
      },
      validateMobile(rule, value, callback) {
        if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)) {
          callback();
        } else {
          callback(this.language['portal.interface.phone.format.incorrect']);
        }

      }
    }
  }
</script>

<style scoped>

</style>